import React from 'react';
import { cn } from '../../utils/cn';

const MARKS = [
  { time: '09:38', label: 'Inserat geht online', signal: false },
  { time: '09:41', label: 'Meldung bei dir', signal: true },
  { time: 'am Abend', label: 'E-Mail-Alarm des Portals', signal: false },
];

/** A real chronology, so a numbered/marked timeline is appropriate (F3: example values). */
export const SpeedTimeline: React.FC = () => (
  <section id="speed" className="scroll-mt-20 border-b border-line bg-page py-16 md:py-24">
    <div className="mx-auto w-full max-w-wide px-4 md:px-6">
      <h2 className="font-display text-2xl text-ink md:text-3xl">Schneller als der Portal-Alarm</h2>

      <ol className="mt-10 flex flex-col gap-6 md:flex-row md:gap-4">
        {MARKS.map((mark, index) => (
          <li key={mark.label} className="relative flex items-start gap-3 md:flex-1 md:flex-col md:items-stretch">
            {index < MARKS.length - 1 && (
              <span aria-hidden="true" className="absolute bottom-[-1.5rem] left-[6px] top-5 w-px bg-line md:hidden" />
            )}
            <div className="flex items-center md:w-full">
              <span
                className={cn('h-3.5 w-3.5 shrink-0 rounded-full border-2 border-card', mark.signal ? 'bg-signal' : 'bg-line-strong')}
                aria-hidden="true"
              />
              {index < MARKS.length - 1 && <span aria-hidden="true" className="ml-2 hidden h-px flex-1 bg-line md:block" />}
            </div>
            <div>
              <p className="tabular font-display text-lg text-ink">{mark.time}</p>
              <p className="text-sm text-muted">{mark.label}</p>
            </div>
          </li>
        ))}
      </ol>

      <p className="mt-8 text-sm text-muted">Beispiel. Die tatsächliche Zeit hängt vom Portal ab.</p>
    </div>
  </section>
);

export default SpeedTimeline;
